// extracted by mini-css-extract-plugin
module.exports = {"spacer":"styles-module--spacer--3Sj-J","content":"styles-module--content--11E6i"};